import { render, staticRenderFns } from "./HighUserPicker.vue?vue&type=template&id=20d6fb6b&scoped=true"
import script from "./HighUserPicker.vue?vue&type=script&lang=js"
export * from "./HighUserPicker.vue?vue&type=script&lang=js"
import style0 from "./HighUserPicker.vue?vue&type=style&index=0&id=20d6fb6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6fb6b",
  null
  
)

export default component.exports